"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_1 = require("mobx");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Button_1 = __importDefault(require("../Button/Button"));

var RedirectButton_meta_1 = require("./RedirectButton.meta");

var RedirectButton =
/** @class */
function (_super) {
  __extends(RedirectButton, _super);

  function RedirectButton(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = RedirectButton_meta_1.REDIRECT_BUTTON_CATEGORY_KEY;
    _this.componentKey = RedirectButton_meta_1.REDIRECT_BUTTON_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(RedirectButton.prototype, "buttonClick", {
    get: function get() {
      var redirect = this.props.redirect;

      var onClick = function onClick(event, payload) {
        if (redirect) {
          var defaultUrl = redirect.defaultUrl,
              base = redirect.base;
          var redirectHelper = new ksys_app_template_1.helpers.RedirectHelper(defaultUrl, base);
          redirectHelper.go(redirect, payload);
        }
      };

      return onClick;
    },
    enumerable: true,
    configurable: true
  });

  RedirectButton.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        redirect = _a.redirect,
        buttonProps = __rest(_a, ["className", "redirect"]);

    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(Button_1.default, __assign({}, buttonProps, {
      onClick: this.buttonClick
    })));
  };

  __decorate([mobx_1.computed], RedirectButton.prototype, "buttonClick", null);

  RedirectButton = __decorate([mobx_react_1.observer], RedirectButton);
  return RedirectButton;
}(shared_1.ComponentBase);

exports.RedirectButton = RedirectButton;
exports.default = shared_1.InjectedStyledComponent(RedirectButton, RedirectButton_meta_1.REDIRECT_BUTTON_CATEGORY_KEY, RedirectButton_meta_1.REDIRECT_BUTTON_COMPONENT_KEY);